import React from 'react';
import PropTypes from 'prop-types';
import * as ReactRedux from 'react-redux';
import { bindActionCreators } from 'redux';
import ReactTooltip from 'react-tooltip';
import * as SelfServeBuilderToolboxActions from './SelfServeBuilderToolboxActions';

export class ToolItemTooltip extends React.PureComponent {
  render() {
    if (!this.props.displayTooltips) {
      return null;
    }

    return (
      <ReactTooltip
        id={this.props.id}
        className={`tool-item-tooltip ${this.props.className}`}
        place="right"
        type="light"
        effect="solid"
        border
      >
        <div>
          <p className="tool-item-tooltip-title">
            {this.props.title}
          </p>
          <p className="tool-item-tooltip-description">
            {this.props.description}
          </p>

          {this.props.example}

          <div
            style={{
              textAlign: 'center',
            }}
          >
            <button
              className="tool-item-tooltip-button"
              onClick={this.props.hideTooltips}
            >
              Hide These Tips
            </button>
          </div>
        </div>
      </ReactTooltip>
    );
  }
}

ToolItemTooltip.defaultProps = {
  example: null,
  displayTooltips: true,
  className: '',
};

ToolItemTooltip.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  description: PropTypes.node.isRequired,
  example: PropTypes.node,
  displayTooltips: PropTypes.bool,
  hideTooltips: PropTypes.func.isRequired,
};

const mapStateToProps = ({ SelfServeBuilderToolboxReducer }) => (
  {
    displayTooltips: SelfServeBuilderToolboxReducer.displayTooltips,
  }
);

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    hideTooltips: SelfServeBuilderToolboxActions.hideTooltips,
  }, dispatch)
);

const ToolItemTooltipWithRedux = ReactRedux.connect(
  mapStateToProps,
  mapDispatchToProps,
)(ToolItemTooltip);

export default ToolItemTooltipWithRedux;



// WEBPACK FOOTER //
// ./src-react/SelfServeBuilderToolbox/ToolItemTooltip.jsx